/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Apikeymanager_Notification_Copied2Inputs */

const id_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API disalin ke clipboard!`)
};

const ms_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API disalin ke papan klip!`)
};

const da_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API nøgle kopieret til udklipsholder!`)
};

const de_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel in die Zwischenablage kopiert!`)
};

const en_us2_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key copied to clipboard!`)
};

const es_es2_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Clave de API copiada al portapapeles!`)
};

const es_mx2_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡API key copiada al portapapeles!`)
};

const fil_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-kopya ang API key sa clipboard!`)
};

const fr_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clé API copiée dans le presse-papiers !`)
};

const it_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiave API copiata negli appunti!`)
};

const hu_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API kulcs a vágólapra másolva!`)
};

const nl_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-sleutel gekopieerd naar klembord!`)
};

const no_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nøkkel kopiert til utklippstavlen!`)
};

const pl_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klucz API skopiowany do schowka!`)
};

const pt_br2_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key copied to clipboard!`)
};

const pt_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chave de API copiada para a área de transferência!`)
};

const ro_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheia API a fost copiată în clipboard!`)
};

const fi_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-avain kopioitu leikepöydälle!`)
};

const sv_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nyckel kopierad till urklipp!`)
};

const vi_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã sao chép khóa API vào clipboard!`)
};

const tr_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API anahtarı panoya kopyalandı!`)
};

const cs_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API klíč zkopírován do schránky!`)
};

const bg_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API ключът е копиран в клипборда!`)
};

const ru_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ скопирован в буфер обмена!`)
};

const uk_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ скопійовано в буфер обміну!`)
};

const ar_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم نسخ مفتاح API إلى الحافظة!`)
};

const hi_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉपी की गई!`)
};

const th_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัดลอกคีย์ API ไปยังคลิปบอร์ดแล้ว!`)
};

const ja_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キーをクリップボードにコピーしました！`)
};

const zh_cn2_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key copied to clipboard!`)
};

const zh_hant1_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key copied to clipboard!`)
};

const ko_components_apikeymanager_notification_copied2 = /** @type {(inputs: Components_Apikeymanager_Notification_Copied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key copied to clipboard!`)
};

/**
* | output |
* | --- |
* | "API key copied to clipboard!" |
*
* @param {Components_Apikeymanager_Notification_Copied2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_apikeymanager_notification_copied2 = /** @type {((inputs?: Components_Apikeymanager_Notification_Copied2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Apikeymanager_Notification_Copied2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_apikeymanager_notification_copied2(inputs)
	if (locale === "ms") return ms_components_apikeymanager_notification_copied2(inputs)
	if (locale === "da") return da_components_apikeymanager_notification_copied2(inputs)
	if (locale === "de") return de_components_apikeymanager_notification_copied2(inputs)
	if (locale === "en-US") return en_us2_components_apikeymanager_notification_copied2(inputs)
	if (locale === "es-ES") return es_es2_components_apikeymanager_notification_copied2(inputs)
	if (locale === "es-MX") return es_mx2_components_apikeymanager_notification_copied2(inputs)
	if (locale === "fil") return fil_components_apikeymanager_notification_copied2(inputs)
	if (locale === "fr") return fr_components_apikeymanager_notification_copied2(inputs)
	if (locale === "it") return it_components_apikeymanager_notification_copied2(inputs)
	if (locale === "hu") return hu_components_apikeymanager_notification_copied2(inputs)
	if (locale === "nl") return nl_components_apikeymanager_notification_copied2(inputs)
	if (locale === "no") return no_components_apikeymanager_notification_copied2(inputs)
	if (locale === "pl") return pl_components_apikeymanager_notification_copied2(inputs)
	if (locale === "pt-BR") return pt_br2_components_apikeymanager_notification_copied2(inputs)
	if (locale === "pt") return pt_components_apikeymanager_notification_copied2(inputs)
	if (locale === "ro") return ro_components_apikeymanager_notification_copied2(inputs)
	if (locale === "fi") return fi_components_apikeymanager_notification_copied2(inputs)
	if (locale === "sv") return sv_components_apikeymanager_notification_copied2(inputs)
	if (locale === "vi") return vi_components_apikeymanager_notification_copied2(inputs)
	if (locale === "tr") return tr_components_apikeymanager_notification_copied2(inputs)
	if (locale === "cs") return cs_components_apikeymanager_notification_copied2(inputs)
	if (locale === "bg") return bg_components_apikeymanager_notification_copied2(inputs)
	if (locale === "ru") return ru_components_apikeymanager_notification_copied2(inputs)
	if (locale === "uk") return uk_components_apikeymanager_notification_copied2(inputs)
	if (locale === "ar") return ar_components_apikeymanager_notification_copied2(inputs)
	if (locale === "hi") return hi_components_apikeymanager_notification_copied2(inputs)
	if (locale === "th") return th_components_apikeymanager_notification_copied2(inputs)
	if (locale === "ja") return ja_components_apikeymanager_notification_copied2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_apikeymanager_notification_copied2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_apikeymanager_notification_copied2(inputs)
	return ko_components_apikeymanager_notification_copied2(inputs)
});
export { components_apikeymanager_notification_copied2 as "components.apiKeyManager.notification.copied" }